module.exports = __webpack_public_path__ + "img/no-results.f1056dd8.svg";